import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { baseUrl } from '../../../baseUrl'
import axios from 'axios'
import PDFViewer from '../../utility/PDFViewer'
import { useAuth } from '../../../AuthContext'

const SingleMaterial = () => {
    const { user } = useAuth();
    console.log(user)
    const params = useParams()
    const [material, setMaterial] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    console.log(material)
    useEffect(() => {
        axios.get(`${baseUrl}/material/get?id=${params.materialID}`)
            .then(res => { setMaterial(res.data) })
            .catch(err => console.log(err))
    }, [])
    const buyMaterial = async () => {
        if (!user) {
            alert('Please login to make a purchase');
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.post(`${baseUrl}/payment/buy-material`, {
                materialId: material._id,
                userId: user ? user.email : null,
                amount: material.price,
                materialName: material.title
            });
            console.log(response)

            if (response.data.msg === 'OK') {
                window.location.href = response.data.url;  // Redirect user to PhonePe payment page
            } else {
                setError(response.data.message);
            }
        } catch (err) {
            setError('Failed to initiate payment. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div style={{ minHeight: '100vh' }}>
            <section className="page-wrapper edutim-course-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="course-single-header">

                                <h3 className="single-course-title">{material.title}</h3>

                                <div className="single-course-meta ">
                                    <ul>

                                        <li>
                                            <span><i className="fa fa-bookmark"></i>{material.className}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="single-course-details ">
                                <h4 className="course-title">Description</h4>
                                <p>{material.description}</p>


                            </div>
                            {/* <h4 className='course-title mt-3 mb-0'>Syllabus</h4>
                            {material.file && <PDFViewer fileUrl={`${material.file}`} />} */}
                        </div>

                        <div className="col-lg-4">
                            <div className="course-sidebar">
                                <div className="course-single-thumb">
                                    <img src={`${process.env.REACT_APP_API_URL}${material.image}`} alt="" className="img-fluid w-100" />
                                    <div className="course-price-wrapper">
                                        <div className="course-price ml-3"><h4>Price: <span className='fs-4 mr-4 ml-2 text-decoration-line-through '>{`₹${material.originalPrice}`}</span><span className='fs-3'>{`₹${material.price}`}</span></h4></div>
                                        {
                                            user === null ?
                                                <div className="buy-btn btn btn-main btn-block">
                                                    Login to buy
                                                </div> :
                                                <div onClick={buyMaterial} className="buy-btn btn btn-main btn-block">
                                                    {isLoading ? 'Processing...' : 'Buy This Material'}
                                                </div>
                                        }
                                        {error && <div className="error">{error}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SingleMaterial
